<template>
  <div class="animated fadeIn">
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small>e</v-btn> مشاهده استعلام‌ها<br/>
          <v-btn elevation="6" outlined small>r</v-btn> مشاهده رابطها و مخاطبین<br/>
          <v-btn elevation="6" outlined small>a</v-btn> مشاهده اقلام سفارش<br/> -->
          <v-btn elevation="6" outlined small>n</v-btn> ثبت رابط جدید
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <b-card
      v-if="
        $router.currentRoute.path ==
        '/' + role + '/customerProfile/' + $route.params.id
      "
    >
      <b-card class="h-100" :class="customer.customer_priority">
        <b-row>
          <b-col cols="6">
            <div class="py-3 px-4">
              <h4>نام مشتری: {{ customer.name }}</h4>
              <hr />

              <h5>شماره اقتصادی: {{ customer.economicalCode }}</h5>
              <h5>شماره ثبت/ شماره ملی : {{ customer.nationalId }}</h5>
              <h5>رتبه مشتری: {{ customer.customer_priority }}</h5>
              <h5>تعداد کل درخواست‌ها: {{ staticOrdersTotalRows }}</h5>
              <h5>استعلام‌های فعال: {{ customer.activeOrderNumber }}</h5>
              <h5>تعداد رابطین: {{ staticTotalRows }}</h5>
              <h5>استان: {{ customer.state }}</h5>
              <h5>شهرستان: {{ customer.province }}</h5>
              <h5>شهر: {{ customer.city }}</h5>
              <h5>آدرس: {{ customer.address }}</h5>
              <h5>کد پستی: {{ customer.postalCode }}</h5>
              <h5>شماره تلفن/ نمابر: {{ customer.tel }}</h5>
            </div></b-col
          >
          <b-col cols="6">
            <div class="py-3 px-4">
              <h4>کد: {{ customer.customer_code }}</h4>
              <hr />
              <h5>سفارش‌ها: {{ customer.factoryNumber }}</h5>
              <h5>جمع کل سفارش‌ها: {{ ordersTotalPrice }}</h5>
              <h5>اقلام سفارش: {{ customerHistory.length }}</h5>
            </div></b-col
          >
        </b-row>
        <!-- <b-btn
          v-if="
            role == 'Manager' || role == 'salesManager' || role == 'secretary'
          "
          class="mr-1"
          @click="showCustomerDialog($route.params.id)"
          >ویرایش</b-btn
        > -->
        <b-row>
          <b-col cols="12">
            <div class="py-3 px-4">
              <h5>
                موبایل سازمانی (جهت دریافت پیامک‌های سیستمی):
                {{ customer.email }}
              </h5>
              <h5>
                ایمیل سازمانی (جهت دریافت ایمیل‌های سیستمی):
                {{ customer.mobile }}
              </h5>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <hr />
      <b-card class="h-100">
        <b-row>
          <h4>اطلاعات فرآیند قیمت‌دهی سامانه</h4>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6">
            <div class="py-3 px-4">
              <h5>
                نرخ تبدیل استعلام به سفارش مشتری :
                {{ customer.exchangeOrderRate }}
              </h5>
              <h5>
                نرخ تبدیل اقلام استعلامی به اقلام سفارشی مشتری :
                {{ customer.exchangeItemRate }}
              </h5>
              <h5>سطح قیمتی مشتری : {{ customer.costLevel }}</h5>
            </div></b-col
          >
          <b-col cols="6">
            <div class="py-3 px-4">
              <h5 style="font-weight: bold">
                ضریب اصلاح مشتری : {{ customer.correctionIndex }}
              </h5>
              <h5>
                تعداد اقلام پیش بینی شده : {{ customer.estimatedItemsNo }}
              </h5>
            </div></b-col
          >
        </b-row>
        <b-btn
          v-if="role == 'Manager' || role == 'salesManager'"
          class="blue mr-1"
          @click="editCorrectionIndex = true"
          >ویرایش ضریب اصلاحی</b-btn
        >
      </b-card>

      <b-tabs pills card content-class="mt-3">
        <b-tab :title="'استعلام‌ها (' + staticOrdersTotalRows + ')'">
          <b-card header-bg-variant="primary" header-text-variant="white">
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <vue-excel-xlsx
                class="darkGreen-mainBtn mb-6 float-end"
                style="width: 135px; height: 35px"
                depressed
                :data="computedOrders(customerOrders, 'allOrders')"
                :columns="requestFields"
                :file-name="`استعلام‌ها`"
                :sheet-name="`استعلام‌ها`"
                :class="
                  computedOrders(customerOrders, 'allOrders').length
                    ? 'white--text'
                    : 'disabled-excel'
                "
              >
                <v-icon
                  class="me-1"
                  :class="
                    computedOrders(customerOrders, 'allOrders').length
                      ? 'white--text'
                      : ''
                  "
                >
                  mdi-file-excel-outline
                </v-icon>
                خروجی اکسل</vue-excel-xlsx
              >
              <b-table
                responsive
                show-empty
                :items="computedOrders(customerOrders, 'allOrders')"
                :fields="fields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPageQuery"
                :per-page="perPage"
                :busy="isBusy"
                id="orders-list"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fields" :key="field.key">
                    <b-form-input
                      v-if="field.key != 'index' && field.key != 'operation'"
                      v-model="toFilterData['allOrders'][field.key]"
                      @input="currentPageQuery = 1"
                      :placeholder="field.label"
                    ></b-form-input>
                    <b-button
                      v-if="field.key == 'operation'"
                      :disabled="!Object.keys(toFilterData['allOrders']).length"
                      variant="danger"
                      @click="
                        toFilterData['allOrders'] = [];
                        currentPageQuery = 1;
                      "
                      >بازنشانی
                    </b-button>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>

                <template v-slot:cell(status)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a :href="data.item.statusLink" target="_blank">{{
                      data.item.status
                    }}</a>
                  </div>
                </template>
                <template v-slot:cell(orderCode)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      :href="'/' + role + '/order/' + data.item.id"
                      target="_blank"
                      >{{ data.item.orderCode }}</a
                    >
                    <span v-if="data.item.isUrgent" class="text-danger">
                      <i class="mr-1 fa fa-exclamation-triangle"> </i>
                      فوری
                    </span>
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPageQuery - 1) }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      class="mx-3 rounded p-2"
                      :href="'/' + role + '/printPreview/full/' + data.item.id"
                      target="_blank"
                    >
                      مالی
                    </a>
                    <a
                      class="mx-3 rounded p-2"
                      :href="
                        '/' + role + '/printPreview/technical/' + data.item.id
                      "
                      target="_blank"
                    >
                      فنی
                    </a>
                  </div>
                </template>
                <div slot="table-isBusy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <div class="d-flex justify-content-center">
                <h6>
                  تعداد:
                  {{ computedOrders(customerOrders, "allOrders").length }}
                </h6>
              </div>
              <b-pagination
                v-model="currentPageQuery"
                :per-page="perPage"
                :total-rows="computedOrders(customerOrders, 'allOrders').length"
                align="center"
                size="md"
                class="my-0"
                aria-controls="orders-list"
              ></b-pagination>
            </b-card>
            <br />
          </b-card>
        </b-tab>
        <b-tab :title="'سفارش‌ها (' + customer.factoryNumber + ')'">
          <b-card header-bg-variant="primary" header-text-variant="white">
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <vue-excel-xlsx
                class="darkGreen-mainBtn mb-6 float-end"
                style="width: 135px; height: 35px"
                depressed
                :data="computedOrders(factoryOrders, 'allOrders')"
                :columns="orderFields1"
                :file-name="`سفارش‌ها`"
                :sheet-name="`سفارش‌ها`"
                :class="
                  computedOrders(factoryOrders, 'allOrders').length
                    ? 'white--text'
                    : 'disabled-excel'
                "
              >
                <v-icon
                  :class="
                    computedOrders(factoryOrders, 'allOrders').length
                      ? 'white--text'
                      : ''
                  "
                  class="me-1"
                >
                  mdi-file-excel-outline
                </v-icon>
                خروجی اکسل</vue-excel-xlsx
              >

              <b-table
                responsive
                show-empty
                :items="computedOrders(factoryOrders, 'allOrders')"
                :fields="orderFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPageOrder"
                :per-page="perPage"
                :busy="isBusy"
                id="orders-list"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in orderFields" :key="field.key">
                    <b-form-input
                      v-if="field.key != 'index'"
                      v-model="toFilterData['allOrders'][field.key]"
                      @input="currentPageOrder = 1"
                      :placeholder="field.label"
                    ></b-form-input>
                    <b-button
                      v-if="field.key == 'index'"
                      :disabled="!Object.keys(toFilterData['allOrders']).length"
                      variant="danger"
                      @click="
                        toFilterData['allOrders'] = [];
                        currentPageOrder = 1;
                      "
                      >بازنشانی
                    </b-button>
                  </td>
                </template>

                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>

                <template v-slot:cell(status)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a :href="data.item.statusLink" target="_blank">{{
                      data.item.status
                    }}</a>
                  </div>
                </template>
                <template v-slot:cell(orderCode)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      :href="'/factory/order/' + data.item.id"
                      target="_blank"
                      >{{ data.item.orderCode }}</a
                    >
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPageQuery - 1) }}
                  </div>
                </template>
                <template v-slot:cell(orderPrice)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value.toLocaleString() + " " + data.item.currency }}
                  </div>
                </template>
                <div slot="table-isBusy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <div class="d-flex justify-content-center">
                <h6>
                  تعداد: {{ computedOrders(factoryOrders, "allOrders").length }}
                </h6>
              </div>
              <b-pagination
                v-model="currentPageOrder"
                :per-page="perPage"
                :total-rows="computedOrders(factoryOrders, 'allOrders').length"
                align="center"
                size="md"
                class="my-0"
                aria-controls="orders-list"
              ></b-pagination>
            </b-card>
            <br />
          </b-card>
        </b-tab>
        <b-tab :title="'رابط‌ها و مخاطبین (' + staticTotalRows + ')'">
          <b-card header-bg-variant="primary" header-text-variant="white">
            <v-row>
              <v-col cols="2">
                <v-btn
                  class="btn btn-primary mb-10 mt-3 text-right"
                  style="border-radius: 10px"
                  variant="primary"
                  @click="showNewAgentDialog()"
                  v-shortkey.once="['n']"
                  @shortkey="showNewAgentDialog()"
                >
                  ثبت رابط جدید
                </v-btn></v-col
              >
              <v-col cols="8"></v-col>

              <v-col cols="2">
                <vue-excel-xlsx
                  class="darkGreen-mainBtn mb-10 mt-3 float-end"
                  style="width: 135px; height: 35px"
                  depressed
                  :data="computedOrders(agents, 'allOrders')"
                  :columns="orderFields2"
                  :file-name="`رایط‌ها`"
                  :sheet-name="`رابط‌ها`"
                  :class="
                    computedOrders(agents, 'allOrders').length
                      ? 'white--text'
                      : 'disabled-excel'
                  "
                >
                  <v-icon
                    class="me-1"
                    :class="
                      computedOrders(agents, 'allOrders').length
                        ? 'white--text'
                        : ''
                    "
                  >
                    mdi-file-excel-outline
                  </v-icon>
                  خروجی اکسل</vue-excel-xlsx
                >
              </v-col>
            </v-row>
            <b-table
              responsive
              show-empty
              :items="computedOrders(agents, 'allOrders')"
              :fields="fields2"
              :current-page="currentPageContact"
              :per-page="perPage"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :busy="isBusy"
              id="agents-table"
            >
              <template slot="top-row" slot-scope="{ fields }">
                <td v-for="field in fields2" :key="field.key">
                  <b-form-input
                    v-if="field.key != 'index'"
                    v-model="toFilterData['allOrders'][field.key]"
                    @input="currentPageContact = 1"
                    :placeholder="field.label"
                  ></b-form-input>
                  <b-button
                    v-if="field.key == 'index'"
                    :disabled="!Object.keys(toFilterData['allOrders']).length"
                    variant="danger"
                    @click="
                      toFilterData['allOrders'] = [];
                      currentPageContact = 1;
                    "
                    >بازنشانی
                  </b-button>
                </td>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(progress)="data">
                <b-progress
                  :value="data.item.progress"
                  variant="success"
                  :striped="striped"
                  show-progress
                  animated
                ></b-progress>
              </template>
              <template v-slot:cell(name)="data">
                <div style="text-align: center; vertical-align: middle">
                  <b-btn
                    variant="link"
                    style="text-color: blue"
                    @click="showAgentDialog(data.item)"
                    >{{ data.item.name }}</b-btn
                  >
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPageContact - 1) }}
                </div>
              </template>
              <div slot="table-isBusy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <div class="d-flex justify-content-center">
              <h6>تعداد: {{ computedOrders(agents, "allOrders").length }}</h6>
            </div>
            <b-pagination
              v-model="currentPageContact"
              :total-rows="computedOrders(agents, 'allOrders').length"
              :per-page="perPage"
              aria-controls="agents-tabel"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
        </b-tab>
        <b-tab :title="'اقلام استعلام (' + customerHistory.length + ')'">
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <vue-excel-xlsx
              class="darkGreen-mainBtn mb-6 float-end"
              style="width: 135px; height: 35px"
              depressed
              :data="computedOrders(filteredHistory, 'allOrders')"
              :columns="fieldsHistoryExcel"
              :file-name="`اقلام استعلام`"
              :sheet-name="`اقلام استعلام`"
              :class="
                computedOrders(filteredHistory, 'allOrders').length
                  ? 'white--text'
                  : 'disabled-excel'
              "
            >
              <v-icon
                class="me-1"
                :class="
                  computedOrders(filteredHistory, 'allOrders').length
                    ? 'white--text'
                    : ''
                "
              >
                mdi-file-excel-outline
              </v-icon>
              خروجی اکسل</vue-excel-xlsx
            >

            <b-table
              responsive
              small
              bordered
              show-empty
              :items="computedOrders(filteredHistory, 'allOrders')"
              :fields="fieldsHistory"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentHistoryPage"
              :per-page="perPage"
              :busy="isBusyHistory"
              @filtered="onFilteredHistory"
            >
              <template slot="top-row">
                <td v-for="field in fieldsHistory" :key="field.key">
                  <b-form-input
                    v-if="field.label != '#'"
                    v-model="toFilterData['allOrders'][field.key]"
                    @input="currentHistoryPage = 1"
                    :placeholder="field.label"
                  ></b-form-input>
                  <b-button
                    v-if="field.key == 'index'"
                    :disabled="!Object.keys(toFilterData['allOrders']).length"
                    variant="danger"
                    @click="
                      toFilterData['allOrders'] = [];
                      currentHistoryPage = 1;
                    "
                    >بازنشانی
                  </b-button>
                </td>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + perPage * (currentHistoryPage - 1) + 1 }}
                </div>
              </template>
              <template v-slot:cell(perPrice)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ sarmadNumber2(data.item) }}
                </div>
              </template>
              <template v-slot:cell(orderCode)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/' + role + '/order/' + data.item.orderId"
                    target="_blank"
                    >{{ data.item.orderCode }}</a
                  >
                </div>
              </template>
              <!-- <template v-slot:cell(totalPrice)="data">{{(parseFloat(sarmadNumber(data.item.perPrice)) * parseInt(data.item.number)).toLocaleString()}}</template>
                <template v-slot:cell(number)="data">{{parseInt(data.item.number).toLocaleString()}}</template>
                <template v-slot:cell(perPrice)="data">{{sarmadNumber(data.item.perPrice).toLocaleString()}}</template>-->

              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
          </b-card>
          <b-pagination
            v-model="currentHistoryPage"
            :per-page="perPage"
            :total-rows="computedOrders(filteredHistory, 'allOrders').length"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-tab>
        <b-tab :title="'اقلام سفارش (' + factoryOrderItems.length + ')'">
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <vue-excel-xlsx
              class="darkGreen-mainBtn mb-6 float-end"
              style="width: 135px; height: 35px"
              depressed
              :data="computedOrders(factoryOrderItems, 'allOrders')"
              :columns="fieldsHistoryExcel2"
              :file-name="`اقلام سفارش`"
              :sheet-name="`اقلام سفارش`"
              :class="
                computedOrders(factoryOrderItems, 'allOrders').length
                  ? 'white--text'
                  : 'disabled-excel'
              "
            >
              <v-icon
                class="me-1"
                :class="
                  computedOrders(factoryOrderItems, 'allOrders').length
                    ? 'white--text'
                    : ''
                "
              >
                mdi-file-excel-outline
              </v-icon>
              خروجی اکسل</vue-excel-xlsx
            >

            <b-table
              responsive
              small
              bordered
              show-empty
              :items="computedOrders(factoryOrderItems, 'allOrders')"
              :fields="fieldsHistory2"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="factoryOrderItemsPage"
              :per-page="perPage"
              :busy="isBusyHistory"
              @filtered="onFilteredFactoryOrderItems"
            >
              <template slot="top-row" slot-scope="{ fields }">
                <td v-for="field in fieldsHistory2" :key="field.key">
                  <b-form-input
                    v-if="field.key != 'index'"
                    v-model="toFilterData['allOrders'][field.key]"
                    @input="factoryOrderItemsPage = 1"
                    :placeholder="field.label"
                  ></b-form-input>
                  <b-button
                    v-if="field.key == 'index'"
                    :disabled="!Object.keys(toFilterData['allOrders']).length"
                    variant="danger"
                    @click="
                      toFilterData['allOrders'] = [];
                      factoryOrderItemsPage = 1;
                    "
                    >بازنشانی
                  </b-button>
                </td>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + perPage * (factoryOrderItemsPage - 1) + 1 }}
                </div>
              </template>
              <template v-slot:cell(perPrice)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ sarmadNumber2(data.item) }}
                </div>
              </template>
              <template v-slot:cell(factoryCode)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/' + role + '/order/' + data.item.orderId"
                    target="_blank"
                    >{{
                      data.item.factoryCode ? data.item.factoryCode : "--"
                    }}</a
                  >
                </div>
              </template>
              <!-- <template v-slot:cell(totalPrice)="data">{{(parseFloat(sarmadNumber(data.item.perPrice)) * parseInt(data.item.number)).toLocaleString()}}</template>
                <template v-slot:cell(number)="data">{{parseInt(data.item.number).toLocaleString()}}</template>
                <template v-slot:cell(perPrice)="data">{{sarmadNumber(data.item.perPrice).toLocaleString()}}</template>-->

              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
          </b-card>
          <b-pagination
            v-model="factoryOrderItemsPage"
            :per-page="perPage"
            :total-rows="computedOrders(factoryOrderItems, 'allOrders').length"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-tab>
      </b-tabs>
    </b-card>
    <v-dialog v-model="agentDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>اطلاعات رابط</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="نام مشتری"
                  :loading="progress"
                  v-model="agent.customerName"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="نام رابط"
                  :loading="progress"
                  v-model="agent.name"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  dir="ltr"
                  label="نام انگلیسی رابط"
                  :loading="progress"
                  v-model="agent.nameEn"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="سمت"
                  :loading="progress"
                  v-model="agent.role"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="تلفن"
                  :loading="progress"
                  v-model="agent.phone"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="تلفن 2"
                  :loading="progress"
                  v-model="agent.phone2"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="داخلی"
                  :loading="progress"
                  v-model="agent.internal"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="فکس"
                  :loading="progress"
                  v-model="agent.fax"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="موبایل"
                  :loading="progress"
                  v-model="agent.mobile"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="ایمیل"
                  :loading="progress"
                  v-model="agent.email"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="کد پستی"
                  :loading="progress"
                  v-model="agent.postalCode"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-textarea
                  outlined
                  dense
                  label="آدرس"
                  rows="3"
                  :loading="progress"
                  v-model="agent.address"
                  filled
                  disabled
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="ضریب اصلاحی"
                  :loading="progress"
                  v-model="agent.correctionIndex"
                  filled
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="deleteMassageDialog = true"
          >
            حذف
          </v-btn>
          <v-btn color="primary" @click="openEditDialog()"> ویرایش</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editAgentDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش مخاطب</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  disabled
                  label="نام مشتری"
                  :loading="progress"
                  v-model="editAgent.customerName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="نام رابط"
                  :loading="progress"
                  v-model="editAgent.name"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  dir="ltr"
                  label="نام انگلیسی رابط"
                  :loading="progress"
                  v-model="editAgent.nameEn"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="سمت"
                  :loading="progress"
                  v-model="editAgent.role"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="موبایل"
                  :loading="progress"
                  v-model="editAgent.mobile"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="ایمیل"
                  :loading="progress"
                  v-model="editAgent.email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="تلفن"
                  :loading="progress"
                  v-model="editAgent.phone"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="تلفن 2"
                  :loading="progress"
                  v-model="editAgent.phone2"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="داخلی"
                  :loading="progress"
                  v-model="editAgent.internal"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="فکس"
                  :loading="progress"
                  v-model="editAgent.fax"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="کد پستی"
                  :loading="progress"
                  v-model="editAgent.postalCode"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-textarea
                  outlined
                  dense
                  label="آدرس"
                  rows="3"
                  :loading="progress"
                  v-model="editAgent.address"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="ضریب اصلاحی"
                  :loading="progress"
                  v-model="editAgent.correctionIndex"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="warning"
            @click="editAgentDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitEditAgent()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newAgentDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ثبت مخاطب جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="نام رابط"
                  v-model="newAgent.newAgentName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  dir="ltr"
                  label="نام انگلیسی رابط"
                  v-model="newAgent.newAgentNameEn"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="سمت"
                  v-model="newAgent.newAgentRole"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="موبایل"
                  v-model="newAgent.newMobile"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="ایمیل"
                  v-model="newAgent.newEmail"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="تلفن"
                  v-model="newAgent.newPhone"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="تلفن 2"
                  v-model="newAgent.newPhone2"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="داخلی"
                  v-model="newAgent.newInternal"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="فکس"
                  v-model="newAgent.newFax"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  dense
                  label="کد پستی"
                  v-model="newAgent.newPostalCode"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-textarea
                  outlined
                  dense
                  label="آدرس"
                  rows="3"
                  v-model="newAgent.newAddress"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="newAgentDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="addAgent()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="toCustomerDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>پیام به</h4>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container>
            <v-text-field
              type="text"
              label="عنوان"
              v-model="subject"
              class="pt-3"
              dense
              outlined
            ></v-text-field>
            <p>متن پیام:</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="contentCustomerModal"
               :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
            <br />
            <v-select
              label="نحوه ارسال پیام"
              :items="options"
              v-model="selected"
              outlined
              dense
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeCustomerMssg()">
            لغو
          </v-btn>
          <v-btn color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteMassageDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>حذف رابط</h4>
        </v-card-title>
        <v-card-text class="py-2 text-center">
          <v-container>
            <h5>آیا از حذف رابط اطمینان دارید؟</h5>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="deleteMassageDialog = false"
          >
            خیر
          </v-btn>
          <v-btn class="mx-auto" color="primary" @click="delAgent()">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editCorrectionIndex" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش ضریب اصلاحی {{ customer.name }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-row>
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="ًضریب اصلاحی"
                  :loading="progress"
                  v-model="correctionIndex"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="warning"
            @click="editCorrectionIndex = false"
          >
            لغو
          </v-btn>
          <v-btn
            color="primary"
            :disabled="isBusy"
            @click="submitEditCorrectionIndex()"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../variables";
import router from "../router";

import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      deleteMassageDialog: false,
      editAgentDialog: false,
      contentCustomerModal: "",
      subject: "",
      customerName: "",
      priority: "",
      file: "",
      agentDialog: false,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "originalRequestId", label: "شماره درخواست" },
        { key: "registerDate", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "نسخه چاپی" },
      ],
      requestFields: [
        { field: "orderCode", label: "کد استعلام" },
        { field: "originalRequestId", label: "شماره درخواست" },
        { field: "registerDate", label: "تاریخ" },
        { field: "status", label: "وضعیت" },
      ],
      orderFields: [
        { key: "index", label: "ردیف" },
        { key: "originalRequestId", label: "شماره درخواست مشتری" },
        { key: "orderCode", label: "کد ردیابی" },
        { key: "factoryDate", label: "تاریخ ابلاغ" },
        { key: "orderPrice", label: "مبلغ کل" },
        { key: "factoryStatus", label: "وضعیت" },
        { key: "priority", label: "اولویت تولید" },
        { key: "progress", label: "پیشرفت (%)" },
      ],
      orderFields1: [
        { field: "originalRequestId", label: "شماره درخواست مشتری" },
        { field: "orderCode", label: "کد ردیابی" },
        { field: "factoryDate", label: "تاریخ ابلاغ" },
        { field: "orderPrice", label: "مبلغ کل" },
        { field: "factoryStatus", label: "وضعیت" },
        { field: "priority", label: "اولویت تولید" },
        { field: "progress", label: "پیشرفت (%)" },
      ],
      ordersTotalPrice: 0,
      searchOpt: ["نام رابط", "شناسه مشتری"],
      filterOrder: null,
      currentPageOrder: 1,
      filter: null,
      currentPageQuery: 1,
      currentPageContact: 1,
      perPage: 10,
      totalRows: 0,
      staticTotalRows: 0,
      queryTotalRows: 0,
      ordersTotalRows: 0,
      staticOrdersTotalRows: 0,
      striped: true,
      isBusy: true,
      totalCost: 0,

      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      Filter: null,
      sortBy: "",
      userInput: "",
      options: [
        { value: "sms", text: "اس‌ام‌اس" },
        { value: "system", text: "سیستمی" },
        { value: "letter", text: "نامه رسمی" },
      ],
      selected: "",
      fields2: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام رابط" },
        // { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        // { key: "phone", label: "تلفن" },
        // { key: "phone2", label: "تلفن 2" },
        // { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        // { key: "email", label: "ایمیل" },
        // { key: "address", label: "آدرس" },
        // { key: "postalCode", label: "کد پستی" },
        { key: "correctionIndex", label: "ضریب اصلاحی" },
        // { key: "operation", label: "عملیات" },
      ],
      orderFields2: [
        { field: "name", label: "نام رابط" },
        { field: "role", label: "سمت" },
        { field: "mobile", label: "موبایل" },
      ],
      agents: [],
      role: "",
      toCustomerDialog: false,
      selected: "",
      newAgentDialog: false,
      filterBusy: false,
      progress: false,
      agent: {},
      newAgent: {},
      editAgent: {},
      customerOrders: [],
      factoryOrders: [],
      factoryOrderItems: [],
      customer: "",
      fieldsHistory: [
        { key: "index", label: "#" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "currency", label: "واحد پول" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "orderCode", label: "کد استعلام" },
      ],
      fieldsHistoryExcel: [
        { field: "details", label: "توضیحات تکمیلی" },
        { field: "customerIndex", label: "ردیف مشتری" },
        { field: "currency", label: "واحد پول" },
        { field: "perPrice", label: "قیمت واحد" },
        { field: "number", label: "واحد" },
        { field: "length", label: "طول" },
        { field: "diameter", label: "قطر" },
        { field: "dimensionStandard", label: "استاندارد ابعاد" },
        { field: "cover", label: "پوشش" },
        { field: "material", label: "متریال" },
        { field: "description", label: "شرح کالا" },
        { field: "orderCode", label: "کد استعلام" },
      ],
      fieldsHistory2: [
        { key: "index", label: "#" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "priority", label: "اولویت تولید" },
        { key: "currency", label: "واحد پول" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "type", label: "نوع محصول" },
        { key: "factoryCode", label: "کد سفارش" },
      ],

      fieldsHistoryExcel2: [
        { field: "details", label: "توضیحات تکمیلی" },
        { field: "customerIndex", label: "ردیف مشتری" },
        { field: "priority", label: "اولویت تولید" },
        { field: "currency", label: "واحد پول" },
        { field: "perPrice", label: "قیمت واحد" },
        { field: "number", label: "واحد" },
        { field: "length", label: "طول" },
        { field: "diameter", label: "قطر" },
        { field: "dimensionStandard", label: "استاندارد ابعاد" },
        { field: "cover", label: "پوشش" },
        { field: "material", label: "متریال" },
        { field: "description", label: "شرح کالا" },
        { field: "type", label: "نوع محصول" },
        { field: "factoryCode", label: "کد سفارش" },
      ],
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      currentHistoryPage: 1,
      isBusyHistory: true,
      historyTotalRows: 0,
      factoryOrderItemsTotalRows: 0,
      factoryOrderItemsPage: 1,
      filtersHistory: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      customerHistory: [],
      allStatuses: [
        { id: 1, name: "ثبت استعلام" },
        { id: 2, name: "در انتظار بررسی فنی" },
        { id: 3, name: "تعیین قیمت توسط مدیر عامل" },
        { id: 4, name: "بررسی تعیین قیمت توسط مدیر فروش" },
        { id: 5, name: "آماده برای امضا" },
        { id: 6, name: "اعلام تعیین قیمت به مشتری" },
        { id: 7, name: "در انتظار نظر مشتری" },
        { id: 8, name: "تایید تعیین قیمت توسط مشتری" },
        { id: 9, name: "رد تعیین قیمت توسط مشتری" },
        { id: 10, name: "عدم" },
        { id: 11, name: "آرشیو" },
        { id: 12, name: "بازبینی تعیین قیمت" },
        { id: 13, name: "آماده ارسال به کارخانه" },
        { id: 14, name: "ارسال به کارخانه" },
      ],
      toFilterData: {
        allOrders: [],
      },
      editCorrectionIndex: false,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    onFilteredContact(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPageContact = 1;
    },
    onFilteredQuery(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.queryTotalRows = filteredItems.length;
      this.currentPageQuery = 1;
    },
    onFilteredOrder(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.ordersTotalRows = filteredItems.length;
      this.currentPageOrder = 1;
    },
    onFilteredHistory(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.historyTotalRows = filteredItems.length;
      this.currentHistoryPage = 1;
    },
    onFilteredFactoryOrderItems(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.factoryOrderItemsTotalRows = filteredItems.length;
      this.factoryOrderItemsPage = 1;
    },
    sarmadNumber2(data) {
      let myCurrency = data.currency
        ? data.currency == "-"
          ? "ریال"
          : data.currency
        : "ریال";
      try {
        let temp1 = parseFloat(data.perPrice).toFixed(
          this.currencyOptions.filter((x) => x.value == myCurrency)[0].precision
        );
        return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
      } catch (error) {
        return "---";
      }
    },
    openEditDialog() {
      this.editAgentDialog = true;
      this.editAgent = JSON.parse(JSON.stringify(this.agent));
    },
    delFilter() {
      this.sortBy = "";
      this.userInput = "";
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agents/getByCustomer",
        { customerId: this.$route.params.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.agents = res.data;
            this.TotalRows = this.agents.length;
            this.staticTotalRows = this.agents.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    delAgent() {
      this.agentDialog = false;
      this.deleteMassageDialog = false;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agent/delete",
        {
          contactId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            const title = (
              <div>
                <h5>حذف مخاطب</h5>
                <span>.مخاطب با موفقیت حذف شد</span>
              </div>
            );
            this.toast(title, "success");
            this.showAgents();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    addAgent() {
      this.newAgentDialog = false;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agent/new",
        {
          customerId: this.$route.params.id,
          name: this.newAgent.newAgentName,
          nameEn: this.newAgent.newAgentNameEn,
          internal: this.newAgent.newInternal,
          role: this.newAgent.newAgentRole,
          phone: this.newAgent.newPhone,
          phone2: this.newAgent.newPhone2,
          fax: this.newAgent.newFax,
          mobile: this.newAgent.newMobile,
          email: this.newAgent.newEmail,
          address: this.newAgent.newAddress,
          postalCode: this.newAgent.newPostalCode,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            const title = (
              <div>
                <h5>ثبت مخاطب</h5>
                <span>.مخاطب جدید با موفقیت ثبت شد </span>
              </div>
            );
            this.toast(title, "success");
            this.showAgents();
            this.newAgent.newAgentName = "";
            this.newAgent.newInternal = "";
            this.newAgent.newAgentRole = "";
            this.newAgent.newPhone = "";
            this.newAgent.newPhone2 = "";
            this.newAgent.newFax = "";
            this.newAgent.newMobile = "";
            this.newAgent.newEmail = "";
            this.newAgent.newPostalCode = "";
            this.newAgent.newAddress = "";
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    submitEditAgent() {
      this.agentDialog = false;
      this.editAgentDialog = false;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agent/edit",
        {
          contactId: this.selected,
          name: this.editAgent.name,
          nameEn: this.editAgent.nameEn,
          internal: this.editAgent.internal,
          role: this.editAgent.role,
          phone: this.editAgent.phone,
          phone2: this.editAgent.phone2,
          fax: this.editAgent.fax,
          mobile: this.editAgent.mobile,
          email: this.editAgent.email,
          address: this.editAgent.address,
          postalCode: this.editAgent.postalCode,
          correctionIndex: this.editAgent.correctionIndex,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            const title = (
              <div>
                <h5>ویرایش مخاطب</h5>
                <span>.مخاطب با موفقیت ویرایش شد </span>
              </div>
            );
            this.toast(title, "success");
            this.showAgents();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getAgentInfo() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agent/getInfo",
        {
          contactId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.progress = false;
          if (res.status == 200) {
            this.agent = JSON.parse(JSON.stringify(res.data));
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    showAgentDialog(agent) {
      this.agent.name = "";
      this.agent.customer = "";
      this.agent.internal = "";
      this.agent.role = "";
      this.agent.phone = "";
      this.agent.phone2 = "";
      this.agent.fax = "";
      this.agent.mobile = "";
      this.agent.email = "";
      this.agent.postalCode = "";
      this.agent.address = "";
      this.agent.correctionIndex = "";
      this.agentDialog = true;
      this.selected = agent.id;
      this.getAgentInfo();
    },
    showNewAgentDialog() {
      this.newAgentDialog = true;
    },
    gotoOrder(item) {
      this.$router.push("/" + this.role + "/order/" + item.id);
    },
    showMssgModal(mssg) {
      this.toCustomerDialog = true;
    },
    closeMssgModal() {
      this.subject = "";
      this.content = "";
      this.selected = "";
      this.toCustomerDialog = false;
    },
    showAgents() {
      Axios.post(
        this.baseUrl + "/ppkpms/agents/getByCustomer",
        { customerId: this.$route.params.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.agents = res.data;
            this.totalRows = this.agents.length;
            this.staticTotalRows = this.agents.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customer/getInfo",
        { customerId: this.$route.params.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customerOrders = res.data.orders;
            this.factoryOrders = res.data.factoryOrders;
            this.factoryOrderItems = res.data.orderItems;
            this.ordersTotalRows = this.factoryOrders.length;
            this.customerOrders.forEach((order) => {
              try {
                order.statusLink =
                  "/" +
                  this.role +
                  "/ordersPerStatus/" +
                  this.allStatuses.filter((x) => x.name == order.status)[0].id;
              } catch (error) {
                order.statusLink = "#";
              }
            });
            let globalCurrency = "";
            let globalCurrencies = [];
            try {
              globalCurrencies = this.factoryOrders.map((x) => x.currency);
              console.log([...new Set(globalCurrencies)]);
              if ([...new Set(globalCurrencies)].length == 1)
                globalCurrency = globalCurrencies[0];
              else globalCurrency = "مختلف";
            } catch (error) {
              globalCurrency = "خطا";
            }
            try {
              this.ordersTotalPrice =
                this.factoryOrders
                  .map((x) => x.orderPrice)
                  .reduce((a, b) => a + b, 0)
                  .toLocaleString() +
                " " +
                globalCurrency;
            } catch (error) {
              this.ordersTotalPrice = "--";
            }

            this.queryTotalRows = this.customerOrders.length;
            this.staticOrdersTotalRows = this.customerOrders.length;
            this.agents = res.data.contacts;
            this.totalRows = this.agents.length;
            this.staticTotalRows = this.agents.length;
            this.customer = res.data.customer;
            this.correctionIndex = res.data.customer.correctionIndex;
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
          this.vLoading = false;
        });
    },
    submitEditCorrectionIndex() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customer/edit/correctionIndex",
        {
          customerId: this.$route.params.id,
          correctionIndex: this.correctionIndex,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editCorrectionIndex = false;
            this.isBusy = false;
            // window.location.reload();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerHistory() {
      this.vLoading = true;

      Axios.post(
        this.baseUrl + "/ppkpms/customer/ordersItems",
        {
          customerId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customerHistory = res.data;
            this.isBusyHistory = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    computedOrders(orders, status) {
      let myAllOrders = orders;
      if (myAllOrders.length) {
        try {
          myAllOrders = myAllOrders.filter((item) => {
            return Object.keys(this.toFilterData[status]).every((key) =>
              String(item[key])
                .toLowerCase()
                .includes(this.toFilterData[status][key].toLowerCase())
            );
          });
        } catch (error) {
          console.log(error);
          myAllOrders = [];
        }
      }

      return myAllOrders;
    },
  },

  computed: {
    filteredHistory() {
      let filteredHistory;
      try {
        filteredHistory = this.customerHistory.filter((item) => {
          return Object.keys(this.filtersHistory).every((key) =>
            String(item[key])
              .toLowerCase()
              .includes(this.filtersHistory[key].toLowerCase())
          );
        });
      } catch (error) {
        filteredHistory = [];
      }
      return filteredHistory;
    },
  },

  mounted() {
    // this.showAgents();
    // this.orderByCustomer();
    this.getCustomerInfo();
    this.getCustomerHistory();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
button.btn.btn-link {
  color: #1976d2 !important;
}

.VIP {
  background-color: rgb(150, 111, 13);
  color: white;
}

.معمولی {
  background-color: rgb(3, 25, 135);
  color: white;
}

.لیست {
  background-color: rgb(224, 10, 10);
  color: black;
}
</style>
